import { render, staticRenderFns } from "./switches.vue?vue&type=template&id=3cee9400&scoped=true&"
import script from "./switches.vue?vue&type=script&lang=js&"
export * from "./switches.vue?vue&type=script&lang=js&"
import style0 from "./switches.vue?vue&type=style&index=0&id=3cee9400&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cee9400",
  null
  
)

export default component.exports